import React from 'react'
import { useTranslation } from 'react-i18next'
import { Layout } from 'ui/layout/Layout'
import { AppBarPatient } from 'ui/partials/AppBar'
import { H2, Text1 } from 'ui/shorthands/Texts'
import CenteredContainer from 'ui/layout/CenteredContainer'
import type { MedicalInstitutionProps } from 'types/applicant'
import type { VerificationTypes } from 'types/common'
import { Button } from '@mui/material'

export type ReservationDoneProps = {
  med: MedicalInstitutionProps
  type: VerificationTypes
  onClick: () => void
}

const ReservationDone: React.FC<ReservationDoneProps> = ({
  med,
  type,
  onClick,
}: ReservationDoneProps) => {
  const { t } = useTranslation()
  return (
    <Layout header={<AppBarPatient>{med.name}</AppBarPatient>} showFooter>
      <CenteredContainer header={<H2>{t('予約が完了しました')}</H2>}>
        <Text1>
          {t('{{label}}を確認してください', {
            label: type === 'sms' ? t('SMSアプリ') : t('メールボックス'),
          })}
        </Text1>
        <Button size="large" color="primary" onClick={onClick}>
          {t('予約詳細の確認')}
        </Button>
      </CenteredContainer>
    </Layout>
  )
}

export default ReservationDone
